var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureActiveDirectory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bdb56329-4717-4410-aa13-4505ecaa4e46",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba2610c3-a45a-4e7e-a0c0-285cfd7e005d",
    x1: 13.25,
    y1: 13.02,
    x2: 8.62,
    y2: 4.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1988d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#54aef0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd8f618b-4f2f-4cb7-aff0-2fd2d211326d",
    x1: 11.26,
    y1: 10.47,
    x2: 14.46,
    y2: 15.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54aef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4fabee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#41a2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2a93e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1988d9"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-identity-221") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.01 10.19 8.93 15.33 16.99 10.17 18 11.35 8.93 17.19 0 11.35 1.01 10.19",
    fill: "#50e6ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1.61 9.53 8.93 0.81 16.4 9.54 8.93 14.26 1.61 9.53",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 0.81 8.93 14.26 1.61 9.53 8.93 0.81",
    fill: "#50e6ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 0.81 8.93 14.26 16.4 9.54 8.93 0.81",
    fill: "url(#ba2610c3-a45a-4e7e-a0c0-285cfd7e005d)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 7.76 16.4 9.54 8.93 14.26 8.93 7.76",
    fill: "#53b1e0"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 14.26 1.61 9.53 8.93 7.76 8.93 14.26",
    fill: "#9cebff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.93 17.19 18 11.35 16.99 10.17 8.93 15.33 8.93 17.19",
    fill: "url(#bd8f618b-4f2f-4cb7-aff0-2fd2d211326d)"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", {
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  }, /*#__PURE__*/React.createElement("rdfLi", null, "public:true"), /*#__PURE__*/React.createElement("rdfLi", null, "sdk:MsPortalFx.Base.Images.Polychromatic.ActiveDirectory()"), /*#__PURE__*/React.createElement("rdfLi", null, "category: Identity")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureActiveDirectory);
export default __webpack_public_path__ + "static/media/Azure-Active-Directory.8dc54f11509ea3c9e892d9d32bb0412e.svg";
export { ForwardRef as ReactComponent };